import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nguix-dashboard-about-page',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutPage implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
